module.exports = __webpack_public_path__ + "static/img/doghead.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doghead.png
// module id = oncf
// module chunks = 1